import Vue from 'vue';
import 'v-markdown-editor/dist/v-markdown-editor.css';
import Editor from 'v-markdown-editor';

// global register
Vue.use(Editor);
